<template>
    <div class="row">
        <div class="columna-abono-5">
            <div class="row">
                <div class="col-12">
                    <TitleComponent title="2. Nuevas altas" subtitle="A) Selecciona el sector en la siguiente tabla:"></TitleComponent>
                </div>
                <div class="col-12">
                    <TablaSectoresComponent :zonas="zonas" v-on:goTo="goTo"></TablaSectoresComponent>
                </div>
            </div>
        </div>
        <div class="columna-abono-7" v-if="zonas">
            <CleSvgComponent 
                v-if="zonas.length > 0"
                :zonas="zonas" 
                :place="place"
                @clickZona="goTo"
            />

            <h3>
                <b>Libres: </b>
                {{ total_libres }}
            </h3>
        </div>
    </div>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent';
import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';

export default {
    props: ['place', 'renovacion', 'zonas'],
    data() {
        return {
            loading: true,
            search: null
        }
    },
    computed: {
        total_libres() {
            var total = 0;

            if(this.zonas && this.zonas.length > 0) {
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].name != 'internacional' && this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'INTERNACIONAL' && this.zonas[i].esta_disponible) {
                        if (this.zonas[i].tiene_plazas) {
                            let libres = this.zonas[i].with_seats ? this.zonas[i].libres : this.zonas[i].aforo;

                            libres = libres - this.zonas[i].count_bloqueados - this.zonas[i].confirmados - this.zonas[i].sesion;

                            total += libres;
                        } else {
                            var libres = this.zonas[i].with_seats ? this.zonas[i].total_asientos : this.zonas[i].aforo;
    
                            libres = libres - this.zonas[i].bloqueados - this.zonas[i].confirmados - this.zonas[i].no_confirmados - this.zonas[i].sesion;
    
                            total = total + libres;
                        }
                    }
                }
            }

            return total;
        }
    },
    methods: {
        goTo(paso, zona) {
            this.$emit('goTo', paso, zona, null);
        }
    },
    components: {
        TitleComponent, TablaSectoresComponent, CleSvgComponent
    }
}
</script>

<style scoped>
    .columna-abono-5, .columna-abono-7 {
        position: relative;
        width: 100%;
        padding-right: 7.5px;
        padding-left: 7.5px;
    }

    .columna-abono-5 {
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .columna-abono-7 {
        -ms-flex: 0 0 58.333333%;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    @media (max-width: 768px) {
        .columna-abono-5 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .columna-abono-7 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
</style>
